import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthGate } from './auth/AuthGate';
import { Home } from './pages/Home';
import { NewSodan } from './pages/NewSodan';
import { CorrespondenceDetail } from './pages/CorrespondenceDetail';
import { Admin } from './pages/Admin';

export default function App() {
  return (
    <AuthGate>
      <Routes>
        {/* Home — recent correspondence list + entry to New SODAN. */}
        <Route path="/" element={<Home />} />
        {/* New SODAN flow. Optional ?policy=<policyYearRef> deep-link
            (e.g. from Renewals Dashboard / Checklists). */}
        <Route path="/new" element={<NewSodan />} />
        {/* Stable per-output URL for deep links + review. */}
        <Route path="/c/:ref" element={<CorrespondenceDetail />} />
        {/* Admin — library editing + user access. Gated inside the page. */}
        <Route path="/admin" element={<Admin />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthGate>
  );
}
